module.exports = __webpack_public_path__ + "static/logo-eyes-5fea524aff1fcd64fadfea1423cf601c.png";